export default __webpack_public_path__ + "static/media/kitchen3.0cae3af2.webp";